import React, { useEffect } from 'react';

import { GIButton } from 'app-components';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { StyledComment } from './AccountActivity.styled';
import { IAccountActivityEvent } from './common/types';
import { FormattedMessage } from 'react-intl';

interface ICustomerNotesSectionProps {
    activeKey: string | null;
    title: string;
    item: IAccountActivityEvent;
    fetchComments: (id: string) => void;
    buttonLabel: string;
    buttonId: string;
    onButtonClick: (eventId: string) => void;
}

export const CustomerNotesSection = ({
    activeKey,
    title,
    item,
    fetchComments,
    buttonLabel,
    buttonId,
    onButtonClick,
}: ICustomerNotesSectionProps) => {
    const { isCommentFetched, id, comments = [] } = item;

    useEffect(() => {
        if (!isCommentFetched) {
            fetchComments(id);
        }
    }, [activeKey, item, fetchComments]);

    const hasComments = comments && comments.length > 0;

    return (
        <div data-testid={`${title}-container`}>
            <ConditionalRendering isTrue={hasComments}>
                <div><FormattedMessage id={title} /></div>
                {comments?.map((comment: any, index: number) => <StyledComment data-testid={`comment-${index}`}  key={index}>{comment}</StyledComment>)}
            </ConditionalRendering>
            <ConditionalRendering isTrue={!hasComments}>
                <GIButton id={buttonId} labelId={buttonLabel} onClickHandler={() => onButtonClick(id)} />
            </ConditionalRendering>
        </div>
    );
};
